import { HandlebarInt, createLiteral } from 'modules/handlebars/domain/literal';
import { NumberValue } from './NumberValue';

export class IntValue extends NumberValue {
  toExpression() {
    return createLiteral(HandlebarInt.parse(this.value));
  }
}
